<template>
  <div id="page-similarArticle">
    <div class="main">
      <ul class="listMessage">
        <li class="listMessage-item" v-for="item in listMessage" :key="item.id">
          <div class="ls">
            <Tag :color="item.tagColor" class="tag-property" style="width:56px">{{item.tagLabel}}</Tag>
          </div>
          <div class="rs">
            <div class="rs-main" @click="turnToSource(item)">
              <div class="message-title">
                <div class="message-link-toSpecGroup" style="display: inline-block">
                  <span class="groupMemberName">{{item.title}}</span>
                </div>
                <span class="messageLanchTime">{{item.date}} {{item.time}}</span>
              </div>
              <div class="message-content" v-html="item.content"></div>
            </div>
            <div class="message-footer-news" v-if="item.source_name==='新闻'">
              <div class="message-footer-ls">
                <div class="keywords-wrapper">
                  关键词：
                  <span class="keywords" v-html="item.keywords"></span>
                </div>
                <div class="frequency-wrapper">
                  词频：
                  <span class="frequency" v-html="item.frequency"></span>
                </div>
                <div class="messageOrigin-wrapper">
                  来源：
                  <span class="messageOrigin">{{item.origin}}</span>
                </div>
              </div>
            </div>
            <div class="message-footer-weibo" v-if="item.source_name==='微博'">
              <div class="message-footer-ls">
                <div class="fansNum-wrapper">
                  粉丝数：
                  <span class="fansNum">{{item.followers_num}}</span>
                </div>
                <div class="commentNum-wrapper">
                  评论量：
                  <span class="commentNum">{{item.comment_num}}</span>
                </div>
                <div class="likeNum-wrapper">
                  点赞量：
                  <span class="likeNum">{{item.like_num}}</span>
                </div>
                <div class="forwardNum-wrapper">
                  转发量：
                  <span class="forwardNum">{{item.forward_num}}</span>
                </div>
              </div>
            </div>
            <div class="message-footer-pubilc" v-if="item.source_name==='公众号'">
              <div class="message-footer-ls">
                <div class="publicAccount-wrapper">
                  公众号：
                  <span class="publicAccount">{{item.origin}}</span>
                </div>
                <div class="frequency-wrapper">
                  词频：
                  <span class="frequency" v-html="item.frequency"></span>
                </div>
                <div class="author-wrapper">
                  作者：
                  <span class="author">{{item.author}}</span>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="page-wrapper" v-show="isShowPage">
        <Page
          :total="listMessage_totalNum"
          :current="currentPage"
          @on-change="changePage"
          show-total
        />
      </div>
    </div>
    <!-- loading动画 --------------------------------------------------------------------------->
    <div class="loading-listMessage-mask" v-show="isLoading_listMessage">
      <div class="loading-listMessage">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //查询文章的条件
      queryData: {
        id: "", //文章id
        uniqueId: "", //文章特征标识（统计相似度）
        startTimeMs: "", //发布时间（起始
        endTimeMs: "", //发布时间（终止）
        pageSize: 10, //页面大小
        pageNum: 1 //当前页码
      },
      //是否正在加载文章列表
      isLoading_listMessage: false,
      //列表数据
      listMessage: [
        // {
        //   id: "1",
        //   tagColor: "error",
        //   tagLabel: "负面",
        //   title: "团贷网人生如梦(3117457348)   QQ群：2819782781",
        //   sourceUrl: "https://www.baidu.com",
        //   content:
        //     "平凡阿非说的非常好，对王岩这种阴险狡诈卑劣小人，立案是唯一行之有效的措施，立案能回来多少钱没人能知道，就知道不立案也没钱回来，至于团贷网头目为什么还有那么多可周转资金就投案自首了，说明他没有后台怕枪毙，王岩为什么不自首还一直牵着所有出借人的鼻子走，兑了二百多元海淀经侦就认可说有诚意，说明他有后台撑腰，不会被枪毙",
        //   //发布者
        //   origin: "新浪财经",
        //   //发布日期
        //   date: "2019-03-30",
        //   //发布时间
        //   time: "19:01",
        //   //关键词
        //   keywords: "团贷网 贷款",
        //   //词频
        //   frequency: "团贷网(20) 立案(5)",
        //   //文章来源
        //   source_name: '新闻',
        //   //如果是微博---------------------------------------------------------------//
        //   //粉丝数
        //   followers_num: 222,
        //   //评论量
        //   comment_num: 666,
        //   //点赞量
        //   like_num: 777,
        //   //转发量
        //   forward_num: 999,
        //   //如果是公众号---------------------------------------------------------------//
        //   author: '老王'
        // }
      ],
      //列表数据的总数目
      listMessage_totalNum: 0,
      //当前页码
      currentPage: 1,
      //如果消息数目为0，则隐藏分页
      isShowPage: true
    };
  },
  created() {
    //初始化文章查询条件
    let urlQuery = this.$route.query;
    this.queryData.id = urlQuery.id;
    this.queryData.uniqueId = urlQuery.uniqueId;
    this.queryData.startTimeMs = urlQuery.startTimeMs;
    this.queryData.endTimeMs = urlQuery.endTimeMs;
    this.queryData.jobId = urlQuery.jobId
    //获取文章列表数据
    this.getMsgListInfo();
  },
  methods: {
    //翻页
    changePage(page) {
      //更新当前页面数据
      this.currentPage = this.queryData.pageNum = page;
      //获取文章列表数据
      this.getMsgListInfo();
    },
    //点击文章跳转到相关来源页
    turnToSource(item) {
      if(item.source_name == '公众号'){
        let date = new Date();
        let nowTime = date.getTime();
        if(nowTime - parseInt(item.update_time) > 6*60*60*1000){
        console.log('guoqi')

          window.open('./wechat?id=' + item.urlid)
        }else{
          window.open(item.sourceUrl);
        }
      }else{
        window.open(item.sourceUrl);
      }
    },
    //获取文章列表数据
    getMsgListInfo() {
      if (this.isLoading_listMessage) return;
      this.isLoading_listMessage = true;
      this.$ajax({
        method: "get",
        url: "./sentiment/longTxtData/similarTxtsList",
        params: this.queryData
      })
        .then(res => {
          this.isLoading_listMessage = false;
          if (res.data.success) {
            //先清空listMessage
            this.listMessage = [];
            this.listMessage_totalNum = res.data.data.total;
            let msgList = res.data.data.detail;
            this.isShowPage = msgList.length>0?true:false;
            for (let i = 0; i < msgList.length; i++) {
              this.listMessage.push({
                id: msgList[i].id,
                tagColor: (function(feeling) {
                  let tagColor = "error";
                  switch (feeling) {
                    case "0":
                      //中性
                      tagColor = "warning";
                      break;
                    case "1":
                      //负面
                      tagColor = "error";
                      break;
                    case "2":
                      //正面
                      tagColor = "success";
                      break;
                    default:
                      break;
                  }
                  return tagColor;
                })(msgList[i].feeling),
                tagLabel: (function(feeling) {
                  let tagLabel = "error";
                  switch (feeling) {
                    case "0":
                      //中性
                      tagLabel = "中性";
                      break;
                    case "1":
                      //负面
                      tagLabel = "负面";
                      break;
                    case "2":
                      //正面
                      tagLabel = "正面";
                      break;
                    default:
                      break;
                  }
                  return tagLabel;
                })(msgList[i].feeling),
                title:
                  msgList[i].search_type === "微博"
                    ? msgList[i].author
                    : msgList[i].title,
                sourceUrl: msgList[i].sourceUrl,
                content:
                  msgList[i].outline.length > 80
                    ? msgList[i].outline.substring(0, 80) + "..."
                    : msgList[i].outline,
                origin: msgList[i].source_name,
                date: (function(publishTime) {
                  let year = new Date(publishTime).getFullYear();
                  let month = (
                    new Date(publishTime).getMonth() +
                    1 +
                    ""
                  ).padStart(2, "0");
                  let day = (new Date(publishTime).getDate() + "").padStart(
                    2,
                    "0"
                  );
                  return `${year}-${month}-${day}`;
                })(parseInt(msgList[i].publishTime)),
                time: (function(publishTime) {
                  let hours = (new Date(publishTime).getHours() + "").padStart(
                    2,
                    "0"
                  );
                  let minutes = (
                    new Date(publishTime).getMinutes() + ""
                  ).padStart(2, "0");
                  return `${hours}:${minutes}`;
                })(parseInt(msgList[i].publishTime)),
                keywords: msgList[i].search_words,
                frequency: (function(keyword_match) {
                  let frequency = "";
                  //先删除所有count为0的数组
                  keyword_match = keyword_match.filter(item => {
                    return item.count > 0;
                  });
                  //然后对剩余数组进行排序
                  let arr_freqency = keyword_match
                    .sort((a, b) => b.count - a.count)
                    .slice(0, 2);
                  if (keyword_match.length === 2) {
                    let arr_freqency = keyword_match
                      .sort((a, b) => b.count - a.count)
                      .slice(0, 2);
                    frequency = `${arr_freqency[0].keyword}(${
                      arr_freqency[0].count
                    })&nbsp;&nbsp;${arr_freqency[1].keyword}(${
                      arr_freqency[1].count
                    })`;
                  } else if (keyword_match.length === 1) {
                    frequency = `${keyword_match[0].keyword}(${
                      keyword_match[0].count
                    })`;
                  }
                  return frequency;
                })(msgList[i].keyword_match ? msgList[i].keyword_match : []),
                followers_num:
                  msgList[i].followers_num === ""
                    ? "0"
                    : msgList[i].followers_num,
                comment_num:
                  msgList[i].comment_num === "" ? "0" : msgList[i].comment_num,
                like_num:
                  msgList[i].like_num === "" ? "0" : msgList[i].like_num,
                forward_num:
                  msgList[i].forward_num === "" ? "0" : msgList[i].forward_num,
                author: msgList[i].author,
                source_name: msgList[i].search_type,
                urlid: msgList[i].urlid,
                update_time: msgList[i].update_time
              });
            }
          } else {
            if (res.data.code !== 405) {
              this.$Message.error("服务器错误");
            }
          }
        })
        .catch(err => {
          this.$Message.error("服务器错误");
          this.isLoading_listMessage = false;
          console.log(err);
        });
    }
  }
};
</script>

<style lang="less">
#page-similarArticle {
  ul {
    list-style-type: none;
  }
  .main {
    width: 1160px;
    margin: 0 auto;
    margin-top: 20px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 34px 98px 46px 98px;
    .listMessage {
      .listMessage-item {
        overflow: hidden;
        width: 964px;
        margin: 0 auto;
        margin-bottom: 40px;
        .ls {
          float: left;
        }
        .rs {
          float: left;
          width: 900px;
          padding-left: 15px;
          .rs-main {
            cursor: pointer;
            .message-title {
              text-align: left;
              .message-link-toSpecGroup {
                display: inline-block;
                border-bottom: 2px solid #fff;
                cursor: pointer;
                box-sizing: border-box;
                .groupMemberName {
                  font-family: PingFangSC-Medium;
                  font-size: 16px;
                  color: #415af6;
                  letter-spacing: 0;
                  line-height: 24px;
                }
                .groupNum {
                  font-family: PingFangSC-Medium;
                  font-size: 16px;
                  color: #415af6;
                  letter-spacing: 0;
                  line-height: 24px;
                  margin-left: 15px;
                }
              }
              .message-link-toSpecGroup:hover {
                box-sizing: border-box;
                border-bottom: 2px solid #fff;
              }
              .messageLanchTime {
                float: right;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #c8c7cc;
                letter-spacing: 0;
              }
            }
            .message-content {
              margin-top: 8px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #666666;
              letter-spacing: 0;
              text-align: left;
              line-height: 22px;
            }
          }

          .message-footer-news {
            overflow: hidden;
            margin-top: 15px;
            .message-footer-ls {
              float: left;
              width: 675px;
              text-align: left;
              display: flex;
              justify-content: space-between;
              .keywords-wrapper {
                width: 225px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #999999;
                letter-spacing: 0;
                line-height: 22px;
                .keywords {
                  color: #333333;
                }
              }
              .frequency-wrapper {
                width: 225px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #999999;
                letter-spacing: 0;
                line-height: 22px;
                .frequency {
                  color: #333333;
                }
              }
              .messageOrigin-wrapper {
                width: 225px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #999999;
                letter-spacing: 0;
                line-height: 22px;
                .messageOrigin {
                  color: #333333;
                }
              }
            }
            .message-footer-rs {
              float: right;
              width: 110px;
              .similarArticle {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #415af6;
                letter-spacing: 0;
                text-align: right;
                cursor: pointer;
                float: right;
              }
            }
          }
          .message-footer-weibo {
            overflow: hidden;
            margin-top: 15px;
            .message-footer-ls {
              float: left;
              width: 680px;
              text-align: left;
              display: flex;
              justify-content: space-between;
              .fansNum-wrapper {
                width: 170px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #999999;
                letter-spacing: 0;
                line-height: 22px;
                .fansNum {
                  color: #333333;
                }
              }
              .commentNum-wrapper {
                width: 170px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #999999;
                letter-spacing: 0;
                line-height: 22px;
                .commentNum {
                  color: #333333;
                }
              }
              .likeNum-wrapper {
                width: 170px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #999999;
                letter-spacing: 0;
                line-height: 22px;
                .likeNum {
                  color: #333333;
                }
              }
              .forwardNum-wrapper {
                width: 170px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #999999;
                letter-spacing: 0;
                line-height: 22px;
                .forwardNum {
                  color: #333333;
                }
              }
            }
            .message-footer-rs {
              float: right;
              width: 105px;
              .similarArticle {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #415af6;
                letter-spacing: 0;
                text-align: right;
                cursor: pointer;
                float: right;
              }
            }
          }
          .message-footer-pubilc {
            overflow: hidden;
            margin-top: 15px;
            .message-footer-ls {
              float: left;
              width: 675px;
              text-align: left;
              display: flex;
              justify-content: space-between;
              .publicAccount-wrapper {
                width: 225px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #999999;
                letter-spacing: 0;
                line-height: 22px;
                .publicAccount {
                  color: #333333;
                }
              }
              .frequency-wrapper {
                width: 225px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #999999;
                letter-spacing: 0;
                line-height: 22px;
                .frequency {
                  color: #333333;
                }
              }
              .author-wrapper {
                width: 225px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #999999;
                letter-spacing: 0;
                line-height: 22px;
                .author {
                  color: #333333;
                }
              }
            }
            .message-footer-rs {
              float: right;
              width: 110px;
              .similarArticle {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #415af6;
                letter-spacing: 0;
                text-align: right;
                cursor: pointer;
                float: right;
              }
            }
          }
        }
      }
    }
    .page-wrapper {
      margin-top: 45px;
    }
  }
  .loading-listMessage-mask {
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    .loading-listMessage {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 500px;
      height: 50px;
    }
    .loading-listMessage span {
      display: inline-block;
      width: 40px;
      height: 40px;
      margin-right: 40px;
      background: #6495ed;
      -webkit-transform-origin: right bottom;
      -webkit-animation: load 1s ease infinite;
    }
    .loading-listMessage span:last-child {
      margin-right: 0px;
    }
    @-webkit-keyframes load {
      0% {
        opacity: 1;
      }
      100% {
        opacity: 0;
        -webkit-transform: rotate(90deg);
      }
    }
    .loading-listMessage span:nth-child(1) {
      -webkit-animation-delay: 0.13s;
    }
    .loading-listMessage span:nth-child(2) {
      -webkit-animation-delay: 0.26s;
    }
    .loading-listMessage span:nth-child(3) {
      -webkit-animation-delay: 0.39s;
    }
    .loading-listMessage span:nth-child(4) {
      -webkit-animation-delay: 0.52s;
    }
    .loading-listMessage span:nth-child(5) {
      -webkit-animation-delay: 0.65s;
    }
  }
}
</style>
